import { ReactNode, useCallback } from "react";
import { CloseCircleOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { EMAIL_RULE } from "../../../lib/validationRules";

export const useStatusLabel = () => {
  const getStatusLabel = useCallback((email: string, error: boolean): ReactNode => {
    if (!EMAIL_RULE.test(email)) {
      return (
        <Tooltip placement="top" title="Invalid Email">
          <ExclamationCircleOutlined className="warning" />
        </Tooltip>
      );
    }

    if (error) {
      return (
        <Tooltip placement="top" title="Sending failed">
          <CloseCircleOutlined className="error" />
        </Tooltip>
      );
    }

    return <div />;
  }, []);

  return { getStatusLabel };
};
